export const Styles = () => ({
  formControl: {
    minWidth: 200,
    maxWidth: 200,
  },
  select: {
    "& .MuiSelect-root": {
      padding: 8,
      border: "1px solid #BDBDBD",
    },
    "& fieldset": {
        height: 45
    }
  },
});
